import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiWrite } from '../lib/api'
import { useEngagements } from '../lib/queries'
import { Empty, PageHead, Skel } from '../components/ui'
import { thaiDate } from '../lib/format'

interface RunResult { run_id: string; scanned: number; created: number; skipped: number; hits: number }

export function Engagements() {
  const q = useEngagements()
  const qc = useQueryClient()
  const [last, setLast] = useState<RunResult | null>(null)
  const run = useMutation({
    mutationFn: (id: string) => apiWrite<RunResult>(`/v1/engagements/${id}/audit-runs`, 'POST', {}),
    onSuccess: (r) => { setLast(r); void qc.invalidateQueries({ queryKey: ['engagements'] }); void qc.invalidateQueries({ queryKey: ['findings'] }) },
  })

  const rows = q.data ?? []

  return (
    <>
      <PageHead title="โครงการตรวจสอบ" sub="ตรวจสอบตามกฎที่กำหนด ไม่ใช่การเดาของโมเดล" />
      {last ? (
        <div className="card card-pad" style={{ marginBottom: 16, borderColor: 'rgba(200,169,106,0.32)' }}>
          <div className="row" style={{ fontSize: 12.5 }}>
            <span className="gold">ตรวจสอบเสร็จสิ้น</span>
            <span className="dim">สแกน {last.scanned} รายการ · สร้างใหม่ {last.created} · ข้ามที่มีอยู่ {last.skipped}</span>
            <button className="btn btn-ghost btn-sm" style={{ marginLeft: 'auto' }} onClick={() => setLast(null)}>ปิด</button>
          </div>
        </div>
      ) : null}
      {q.isLoading ? <div className="stack"><Skel h={64} /><Skel h={64} /><Skel h={64} /></div>
        : rows.length === 0 ? <div className="card"><Empty title="ยังไม่มีโครงการ" body="สร้างโครงการตรวจสอบเพื่อเริ่มใช้งาน" /></div>
        : (
          <div className="table-wrap">
            <table className="data">
              <thead><tr><th>โครงการ</th><th>ช่วงเวลา</th><th>รายการ</th><th>ข้อสังเกต</th><th>สถานะ</th><th /></tr></thead>
              <tbody>
                {rows.map((e) => (
                  <tr key={e.id} style={{ cursor: 'default' }}>
                    <td>
                      <div>{e.title}</div>
                      <div className="mono dim" style={{ fontSize: 11, marginTop: 3 }}>{e.code}</div>
                    </td>
                    <td className="dim">{thaiDate(e.period_start)} — {thaiDate(e.period_end)}</td>
                    <td className="tnum">{e.transaction_count}</td>
                    <td className="tnum">{e.finding_count} <span className="dim">({e.open_findings} เปิด)</span></td>
                    <td><span className="chip">{e.status}</span></td>
                    <td className="num">
                      <button className="btn btn-sm" disabled={run.isPending} onClick={() => run.mutate(e.id)}>
                        {run.isPending && run.variables === e.id ? 'กำลังตรวจ…' : 'รันการตรวจสอบ'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </>
  )
}
